import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/');
          return;
        }

        const response = await axios.post(
          `${API_URL}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const token = response.data.session_token;
        if (token) {
          localStorage.setItem('session_token', token);
        }

        setUser(response.data.user);
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Auth error:', error);
        const errorMsg = error.response?.data?.detail || 'Falha na autenticação';
        navigate('/', { state: { error: errorMsg }, replace: true });
      }
    };

    processAuth();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F7F8]">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#AF2628] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#6E6E73]">Autenticando...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
